// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PoliticsModule_wrapper__AEXWd"};